import Users from "features/Admin/Users";
import GeneralParameters from "features/Admin/GeneralParameters";
import Analyses from "features/Admin/Analyses";
import AnalysesPacks from "features/Admin/AnalysesPacks";
import Tubes from "features/Admin/Tubes";
import Questions from "features/Admin/Questions";
import SystematicQuestions from "features/Admin/QuestionsSystematic";
import Motivations from "features/Admin/Motivations";
import Answers from "features/Admin/Answers";
import Insurances from "features/Admin/Insurances";
import SpecialRegimes from "features/Admin/SpecialRegimes";
import Specialties from "features/Admin/Specialties";
import Companies from "features/Admin/Companies";
import LabParamGroups from "features/Admin/LabParamGroups";
import Laboratories from "features/Admin/Laboratories";
import EmergencyReasons from "features/Admin/EmergencyReasons";
import ContactComments from "features/Admin/ContactComments";
import TubeReasons from "features/Admin/TubeReasons";
import Centers from "features/Admin/Centers";
import Boxes from "features/Admin/Boxes";
import Logs from "features/Admin/Logs";
import ConsentRefusalReasons from "features/Admin/ConsentRefusalReasons";
import SampleTypes from "features/Admin/SampleTypes";
import DocumentTypes from "features/Admin/DocumentTypes";
import Dashboard from "features/Admin/Dashboard";
import ValidationPausedReasons from "features/Admin/ValidationPausedReasons";
import OpenedFolders from "features/Admin/OpenedFolders";
import HelpNurses from "features/Admin/HelpNurses";
import Payment from "features/Admin/Payment";
import Notice from "features/Admin/Notice";
import ServipayTerminal from "features/Admin/ServipayTerminal";
import Scanners from "features/Admin/Scanners";
import LivePatientCall from "features/Admin/Live";
import { Translations } from "features/Admin/Translations";
import Preregister from "features/Admin/Preregister";
import AnalysesPacksPrescriber from "features/Admin/AnalysesPacksPrescriber";
import PartnerCompanies from "features/Admin/PartnerCompanies/index";
import CancelReasons from "features/Admin/CancelReasons";
import Facturation from "features/Admin/Facturation";
import ExternalServices from "features/Admin/ExternalServices/index";
import Campagnes from "features/Admin/Campagnes/index";
import NurseMobility from "features/NurseMobility/index";

const routes = [
	{
		path: "/admin/users",
		exact: false,
		component: Users,
	},
	{
		path: "/admin/general",
		exact: false,
		component: GeneralParameters,
	},
	{
		path: "/admin/analyses",
		exact: false,
		component: Analyses,
	},
	{
		path: "/admin/analysesPacks",
		exact: false,
		component: AnalysesPacks,
	},
	{
		path: "/admin/tubes",
		exact: false,
		component: Tubes,
	},
	{
		path: "/admin/questions",
		exact: false,
		component: Questions,
	},
	{
		path: "/admin/systematicQuestions",
		exact: false,
		component: SystematicQuestions,
	},
	{
		path: "/admin/motivations",
		exact: false,
		component: Motivations,
	},
	{
		path: "/admin/answers",
		exact: false,
		component: Answers,
	},
	{
		path: "/admin/insurances",
		exact: false,
		component: Insurances,
	},
	{
		path: "/admin/specialRegimes",
		exact: false,
		component: SpecialRegimes,
	},
	{
		path: "/admin/specialties",
		exact: false,
		component: Specialties,
	},
	{
		path: "/admin/companies",
		exact: false,
		component: Companies,
	},
	{
		path: "/admin/labParamGroups",
		exact: false,
		component: LabParamGroups,
	},
	{
		path: "/admin/laboratories",
		exact: false,
		component: Laboratories,
	},
	{
		path: "/admin/emergencyReasons",
		exact: false,
		component: EmergencyReasons,
	},
	{
		path: "/admin/validationPausedReasons",
		exact: false,
		component: ValidationPausedReasons,
	},
	{
		path: "/admin/servipayTerminal",
		exact: false,
		component: ServipayTerminal,
	},
	{
		path: "/admin/tubeReasons",
		exact: false,
		component: TubeReasons,
	},
	{
		path: "/admin/cancelReasons",
		exact: false,
		component: CancelReasons,
	},
	{
		path: "/admin/contactComments",
		exact: false,
		component: ContactComments,
	},
	{
		path: "/admin/partners",
		exact: false,
		component: PartnerCompanies,
	},
	{
		path: "/admin/centers",
		exact: false,
		component: Centers,
	},
	{
		path: "/admin/box",
		exact: false,
		component: Boxes,
	},
	{
		path: "/admin/logs",
		exact: false,
		component: Logs,
	},
	{
		path: "/admin/consentRefusalReasons",
		exact: false,
		component: ConsentRefusalReasons,
	},
	{
		path: "/admin/sampleTypes",
		exact: false,
		component: SampleTypes,
	},
	{
		path: "/admin/documentTypes",
		exact: false,
		component: DocumentTypes,
	},
	{
		path: "/admin/dashboard",
		exact: false,
		component: Dashboard,
	},
	{
		path: "/admin/folders/opened",
		exact: false,
		component: OpenedFolders,
	},
	{
		path: "/admin/helpNurses",
		exact: false,
		component: HelpNurses,
	},
	{
		path: "/admin/payment",
		exact: false,
		component: Payment,
	},
	{
		path: "/admin/notifications",
		exact: false,
		component: Notice,
	},
	{
		path: "/admin/scanner",
		exact: false,
		component: Scanners,
	},
	{
		path: "/admin/live",
		exact: false,
		component: LivePatientCall,
	},
	{
		path: "/admin/translate",
		exact: false,
		component: Translations,
	},
	{
		path: "/admin/analysesPacksPrescriber",
		exact: false,
		component: AnalysesPacksPrescriber,
	},
	{
		path: "/admin/preregister",
		exact: false,
		component: Preregister,
	},

	{
		path: "/admin/facturation",
		exact: false,
		component: Facturation,
	},
	{
		path: "/admin/externalServices",
		exact: false,
		component: ExternalServices,
	},
	{
		path: "/admin/campaigns",
		exact: false,
		component: Campagnes,
	},
	{
		path: "/admin/mobility",
		exact: false,
		component: NurseMobility,
	},
];

export default routes;
